import HeaderUser from '../components/HeaderUser/HeaderUser'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toggleUserInfoModal, toggleMobileSubMenu, toggleMobileMenu } from '../modules/settings'

const mapStateToProps = (state, props) => ({
  openUserInfoModal: state.settings.openUserInfoModal,
  openMobileSubMenu: state.settings.openMobileSubMenu,
  openMobileMenu: state.settings.openMobileMenu,
  campaign: state.signup.campaign,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleUserInfoModal,
  toggleMobileSubMenu,
  toggleMobileMenu
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderUser)



// WEBPACK FOOTER //
// ./src/containers/HeaderUserContainer.js